import { getIdToken } from "firebase/auth";
import { auth } from "../firebase/firebase-config";

export const getAuthHeader = async () => {
    const currentUser = auth.currentUser;
    if (currentUser) {
        const token = await getIdToken(currentUser, false);
        const headers: Record<string, string> = { 
            Authorization: `Bearer ${token}` 
        };
        
        // Add impersonation token if present
        const impersonationToken = sessionStorage.getItem("impersonationToken");
        if (impersonationToken) {
            headers["x-impersonation-token"] = impersonationToken;
        }
        
        return headers;
    }
    throw new Error("User is not authenticated");
};
